module.exports = __webpack_public_path__ + "img/1.3cba2b79.png";